'use client';

import { useContext } from 'react';
import { TabPanelProps } from 'types';
import { TabsContext } from './TabsContext';

type TabPanelCssProps = {};

type TabPanelComponentProps = TabPanelProps & TabPanelCssProps;

export function TabPanel({ tabId, children }: TabPanelComponentProps) {
  const { selectedTabId } = useContext(TabsContext);

  return tabId === selectedTabId ? <>{children}</> : null;
}

TabPanel.displayName = 'Tabs.TabPanel';
